import axios from "axios";

export const fetchFileInfo = async (fileUrl: string, shouldDeleteDate?: boolean) => {
  try {
    if (!fileUrl) {
      return null;
    }
    const response = await axios.get(fileUrl, { responseType: "blob" });

    const blob = response.data;

    const parts = fileUrl.split("/");
    const encodedFileName = parts[parts.length - 1] || "";
    const decodedFileName = decodeURIComponent(encodedFileName);

    if (!shouldDeleteDate) {
      return {
        name: decodedFileName,
        size: blob.size,
      };
    }

    const nameWithoutDate = decodedFileName.split("-").slice(1).join("-");

    return {
      name: nameWithoutDate,
      size: blob.size,
    };
  } catch {
    return null;
  }
};
